import { render, staticRenderFns } from "./FlashAlert.vue?vue&type=template&id=3be2fbd0"
import script from "./FlashAlert.vue?vue&type=script&lang=js"
export * from "./FlashAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports